import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SucessSubmitModal from './dialogs/SucessSubmitContainer'
import View from './View'
import { putIdeaTemplateEdit ,getIdeaTemplateEditID} from 'services/innovate/templates'

const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  createIdeaTemplateLoading: state.data.templates.createIdeaTemplateLoading,
  updateIdeaTemplateLoading: state.data.templates.updateIdeaTemplateLoading,
  editIdIdeaTemplateLoading: state.data.templates.editIdIdeaTemplateLoading,
  createIdeaTemplate:state.data.templates.createIdeaTemplate,
  updateIdeaTemplate:state.data.templates.updateIdeaTemplate,
  editIdIdeaTemplateData:state.data.templates.editId_IdeaTemplate,
})

const mapDispatchToProps = dispatch => {
  return {
    putIdeaTemplateEditFn:(email,IdeaTemplateJsonValue=[],id)=>{
      console.log("edit Value", IdeaTemplateJsonValue)

      const onSuccess = data => {
        const message='Your Idea Template is Successfully Save'
        // showPopupSuccessSnackbar(message, dispatch)
        showPopupDialog(<SucessSubmitModal description={message} />, dispatch)
      }
      const onFailure = ({ data }) => {
        const messageTag =
        data && data?.error && data?.error?.en
          ? `BACKEND_ERRORS.${data?.error?.en}`
            : 'BACKEND_ERRORS.UNEXPECTED'
            showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
      }
      dispatch(putIdeaTemplateEdit(email,IdeaTemplateJsonValue,id,onSuccess,onFailure))

    },
    getIdeaTemplateEditIDFn:(templateIdParams)=>{
      dispatch(getIdeaTemplateEditID(templateIdParams))
    }

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)